import CryptoJS from 'crypto-js';
import { uploadTgCloudStorage, downloadTgCloudStorage, clearTgCloudStorage } from '../utils/telegramCloudStorage';

export interface QssMnemonic {
    network: string
    name: string
    mnemonic: string
}

export interface QssMnemonicHash {
    network: string
    name: string
    mnemonicHash: string
}

// QSS 니모닉 전체 구조
export interface StructQssMnemonic {
    mnemonicHashList: QssMnemonicHash[]; // 니모닉 해시 배열
    mnemonicEnc: EncAES; // 니모닉정보 암호화된 값
}

// AES 암호화 결과
export interface EncAES {
    encrypted: string;
    salt: string;
    iv: string;
}

const useQssMnemonic = () => {
    
    const KEY_QSS_MNEMONIC = `qss_mnemonic` // 니모닉 저장 키

    //----------------------------------------------------------------------//
    // AES
    // PBKDF2 키 유도 함수 (동기적으로 동작)
    const deriveKey = (password: string, salt: string): CryptoJS.lib.WordArray => {
        // PBKDF2 with 10000 iterations and 256-bit key
        const key = CryptoJS.PBKDF2(password, CryptoJS.enc.Hex.parse(salt), {
            keySize: 256 / 32, // 256-bit key
            iterations: 10000,
            hasher: CryptoJS.algo.SHA256
        });
        return key;
    };

    // 데이터 암호화 함수
    const encryptValue = (password: string, data: string): { encrypted: string, salt: string, iv: string } => {
        try {
            // 랜덤한 salt 생성 (16바이트)
            const salt = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);

            // PBKDF2를 사용하여 키 유도
            const key = deriveKey(password, salt);

            // 랜덤한 IV 생성 (16바이트)
            const iv = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);

            // AES-CBC 모드를 사용하여 데이터 암호화
            const encrypted = CryptoJS.AES.encrypt(data, key, {
                iv: CryptoJS.enc.Hex.parse(iv),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString();

            // 암호화된 데이터와 함께 salt, iv 반환
            return {
                encrypted,
                salt,
                iv
            };
        } catch (error) {
            console.warn(`Error encryptValue`, error);
        }

        return { encrypted: '', salt: '', iv: '' };
    };

    // 데이터 복호화 함수
    const decryptValue = (password: string, encryptedData: { encrypted: string, salt: string, iv: string }): string => {
        try {
            const { encrypted, salt, iv } = encryptedData;

            // PBKDF2를 사용하여 키 유도
            const key = deriveKey(password, salt);

            // AES-CBC 모드를 사용하여 데이터 복호화
            const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
                iv: CryptoJS.enc.Hex.parse(iv),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            // 복호화된 데이터를 UTF-8 문자열로 변환
            const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
            return decryptedText;
        } catch (error) {
            console.warn(`Error decryptValue`, error);
        }

        return '';
    };
    //----------------------------------------------------------------------//

    //----------------------------------------------------------------------//
    // 3DES 
    // PBKDF2 키 유도 함수 (동기적으로 동작)
	// const deriveKey = (password: string, salt: string): CryptoJS.lib.WordArray => {
	// 	// PBKDF2 with 10000 iterations and 192-bit key (3DES는 최대 192-bit 키 사용)
	// 	const key = CryptoJS.PBKDF2(password, CryptoJS.enc.Hex.parse(salt), {
	// 		keySize: 192 / 32, // 192-bit key
	// 		iterations: 10000,
	// 		hasher: CryptoJS.algo.SHA256
	// 	});
	// 	return key;
	// };

	// // 데이터 암호화 함수
	// const encryptValue = (password: string, data: string): { encrypted: string, salt: string, iv: string } => {
	// 	try {
	// 		// 랜덤한 salt 생성 (16바이트)
	// 		const salt = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);

	// 		// PBKDF2를 사용하여 키 유도
	// 		const key = deriveKey(password, salt);

	// 		// 랜덤한 IV 생성 (8바이트, 3DES는 64-bit 블록 크기)
	// 		const iv = CryptoJS.lib.WordArray.random(8).toString(CryptoJS.enc.Hex);

	// 		// 3DES-CBC 모드를 사용하여 데이터 암호화
	// 		const encrypted = CryptoJS.TripleDES.encrypt(data, key, {
	// 			iv: CryptoJS.enc.Hex.parse(iv),
	// 			mode: CryptoJS.mode.CBC,
	// 			padding: CryptoJS.pad.Pkcs7
	// 		}).toString();

	// 		// 암호화된 데이터와 함께 salt, iv 반환
	// 		return {
	// 			encrypted,
	// 			salt,
	// 			iv
	// 		};
	// 	} catch (error) {
	// 		console.error(`Error encryptValue`, error);
	// 	}

	// 	return { encrypted: '', salt: '', iv: '' };
	// };

	// // 데이터 복호화 함수
	// const decryptValue = (password: string, encryptedData: { encrypted: string, salt: string, iv: string }): string => {
	// 	try {
	// 		const { encrypted, salt, iv } = encryptedData;

	// 		// PBKDF2를 사용하여 키 유도
	// 		const key = deriveKey(password, salt);

	// 		// 3DES-CBC 모드를 사용하여 데이터 복호화
	// 		const decrypted = CryptoJS.TripleDES.decrypt(encrypted, key, {
	// 			iv: CryptoJS.enc.Hex.parse(iv),
	// 			mode: CryptoJS.mode.CBC,
	// 			padding: CryptoJS.pad.Pkcs7
	// 		});

	// 		// 복호화된 데이터를 UTF-8 문자열로 변환
	// 		const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
	// 		return decryptedText;
	// 	} catch (error) {
	// 		console.error(`Error decryptValue`, error);
	// 	}

	// 	return '';
	
    // };
    //----------------------------------------------------------------------//

    // sha256 hash 생성
    const hashSha256Value = async (data: string): Promise<string> => {
        try {
            const hash = CryptoJS.SHA256(data).toString();
            return hash
        } catch (error) {
            console.warn(`Error hashSha256Value`, error);
        }

        return ''
    };
    
    /**
     * 텔레그램 클라우트 스토리지 키
     * @param key 
     * @returns 
     */
    const getTelegramStorageKey = async (addKey: string) => {
        
        // 이전 방식 공통 키 사용
        // const key = KEY_QSS_MNEMONIC.toString();
        // 네트워크 별 키 구분 사용
        const key = `${KEY_QSS_MNEMONIC.toString()}_${addKey}`;
        
        console.log(`getTelegramStorageKey key`, key)
        return key;

    }

    /**
     * 중복된 QSS 니모닉해시가 있는지 확인
     * @param mnemonicHash 
     * @param network 
     * @returns 
     */
    const checkOverlapQssMnemonicHash = async (mnemonicHash: string, network: string) => {
        try {
            // tg cloud 에 저장된 니모닉 해시값 배열 가져오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)
            // console.log(`checkOverlapQssMnemonicHash key : ${key} | qssValue : `, qssValue)

            if(null == qssValue || '' === qssValue) {
                // 저장된 니모닉 데이터가 없을 경우 리턴
                console.log(`checkOverlapQssMnemonicHash qssMnemonicHash is empty`)
                return false
            }

            const parsedData = JSON.parse(qssValue.toString());
            // console.log(`checkOverlapQssMnemonicHash parsedData`, parsedData)

            // json 배열 형태로 변경
            const hashJsonArray = parsedData.mnemonicHashList
            // console.log(`checkOverlapQssMnemonicHash - hashJsonArray`, hashJsonArray)
            // console.log(`checkOverlapQssMnemonicHash - mnemonicHash`, mnemonicHash)

            // 중복된 니모닉 해시값이 있는지 확인
            if( false === await isMnemonicHashDuplicate(hashJsonArray, mnemonicHash, network) ) {
                return false
            }

            return true
        } catch (error) {
            console.log(`Error checkOverlapQssMnemonicHash : `, error)
        }

        return false
    };

    /**
     * qss 니모닉해시 가져오기
     * @param network 
     * @returns 
     */
    const getQssMnemonicHash = async (network: string) => {
        let result = false;
        let value = null;

        try {
            // QSS 니모닉 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)

            if(null == qssValue || '' === qssValue) {
                // 없을 경우 리턴하고 종료
                console.log(`getQssMnemonicHash qssHashValue is empty`)
                result = false;
                return {result, value};
            } 
            
            // QSS 데이터 값 json 배열 형태로 변경
            const parsedJsonData = JSON.parse(qssValue.toString());
            console.log(`getQssMnemonicHash QSS 배열 : `, parsedJsonData)

            // QSS 니모닉해시 배열로 변경
            const hashJsonArray: QssMnemonicHash[] = parsedJsonData.mnemonicHashList;

            if(0 === hashJsonArray.length) {
                console.log(`getQssMnemonicHash hashJsonArray length 0`)
                result = false;
                return {result, value};
            }

            // 니모닉해시 데이터 리턴
            result = true
            value = hashJsonArray
            return {result, value};
        } catch (error) {
            // 리턴하고 종료
            console.warn('Error getQssMnemonicHash', error);
        }

        return {result, value};
    }


    /**
     * 이전에 저장된 qSS 니모닉 데이터 없는지 확인
     * @param network 
     * @returns boolean
     */
    const checkEmptyQssMnemonic = async (network: string) => {
        try {
            // 기존에 qss 저장된 암호화된 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)
            // console.log(`checkEmptyQssMnemonic network : ${network} | key : ${key} | qssValue : `, qssValue)

            if(null == qssValue || '' === qssValue) {
                console.log('checkEmptyQssMnemonic 데이터 없음');
                return true;
            } else if(null != qssValue && '' !== qssValue) {
                const parsedJsonData = JSON.parse(qssValue.toString());
                if(null == parsedJsonData.mnemonicHashList || 0 === parsedJsonData.mnemonicHashList.length) {
                    console.log('checkEmptyQssMnemonic mnemonicHashList 데이터 없음', parsedJsonData);
                    return true;
                }
            }
        } catch(error) {
            console.warn('Error checkEmptyQssMnemonic', error);
        }

        return false;
    };

    /**
     * 이전 데이터 형식인지 확인
     * @param network 
     * @returns boolean
     */
    const checkOldQssData = async (network: string) => {
        try {
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)
            // console.log(`checkOldQssMnemonic qssValue`, qssValue)

            if(null != qssValue && '' !== qssValue) {
                const parsedJsonData = JSON.parse(qssValue.toString());
                // mnemonicHashList 와 mnemonicEnc 가 모두 없는지 확인
                if (!parsedJsonData.hasOwnProperty('mnemonicHashList') && !parsedJsonData.hasOwnProperty('mnemonicEnc')) {
                    console.log('이전 버전 QSS 데이터 입니다');
                    return true;
                }
            } 
        } catch(error) {
            console.warn('Error checkEmptyQssMnemonic', error);
        }

        return false;
    }

    /**
     * qss 니모닉 암호화 비밀번호 일치하는지 확인
     * @param password 
     * @param network 
     * @returns 
     */
    const chackQssPassword = async (password: string, network: string) => {

        try {
            // 기존에 qss 저장된 암호화된 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)

            if(null == qssValue || '' === qssValue) {
                // 데이터가 없을 경우 리턴하고 종료
                console.log(`chackQssPassword qssValue is empty`)
                return true;
            } 
            // console.log(`chackQssPassword qssValue : `,qssValue)

            // json parse 처리
            const parsedData = JSON.parse(qssValue.toString());
            // console.log(`chackQssPassword parsedData : `, parsedData)

            // 암호화된 mnemonicEnc 데이터
            const mnemonicEnc = parsedData.mnemonicEnc
            // console.log(`chackQssPassword mnemonicEnc : `, mnemonicEnc)
            
            // 니모닉 복호화
            const decryptedValue = decryptValue(password, mnemonicEnc);
            // console.log(`chackQssPassword decryptedValue : `, decryptedValue)

            // 복호화가 성공하면 복호화된 stringfy 된 json 데이터를 json parse
            const decJsonArray = JSON.parse(decryptedValue.toString());
            // console.log(`chackQssPassword 복호화된 니모닉 배열 : `, decJsonArray)

            // 복호화 결과, 복호화 데이터 리턴
            return true
        } catch (error) {
            // 복호화기 실패하면 리턴하고 종료
            console.warn('Error getQssMnemonic', error);
        }

        return false
    };

    /**
     * qss에 저장된 니모닉 코드 가져오기
     * @param password 
     * @param network 
     * @returns 
     */
    const getQssMnemonic = async (password: string, network: string) => {
        let result = false;
        let value = null;

        try {
            // 기존에 qss 저장된 암호화된 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)

            if(null == qssValue || '' === qssValue) {
                // 데이터가 없을 경우 리턴하고 종료
                console.log(`getQssMnemonic qssValue is empty`)
                result = true;
                return {result, value};
            } 
            
            // json parse 처리
            const parsedData = JSON.parse(qssValue.toString());
            // console.log(`getQssMnemonic parsedData : `, parsedData)

            // 암호화된 mnemonicEnc 데이터
            const mnemonicEnc = parsedData.mnemonicEnc
            // console.log(`getQssMnemonic mnemonicEnc : `, mnemonicEnc)
            
            // 복호화
            const decryptedValue = decryptValue(password, mnemonicEnc);
            // console.log(`getQssMnemonic decryptedValue : `, decryptedValue)

            // 복호화가 성공하면 복호화된 stringfy 된 json 데이터를 json parse
            const decJsonArray = JSON.parse(decryptedValue.toString());
            // console.log(`getQssMnemonic 복호화된 니모닉 배열 : `, decJsonArray)

            // 복호화 결과, 복호화 데이터 리턴
            result = true
            value = decJsonArray
            return {result, value};
        } catch (error) {
            // 복호화기 실패하면 리턴하고 종료
            console.warn('Error getQssMnemonic', error);
        }

        return {result, value};
    };

    /**
     * qss에 니모닉 저장
     * @param password : 암호화 키
     * @param networkName : 니모닉정보 추가할 네트워크(체인) 이름
     * @param name : 니모닉이름
     * @param newMnemonic : 니모닉코드
     * @returns 
     */
    const addQssMnemonic = async (password: string, networkName:string, name: string, newMnemonic: string) => {
        try {
            if( null == networkName || '' === networkName) {
                console.log(`addQssMnemonic networkName 값 오류`, networkName)
                return false
            }
            else if( null == name || '' === name) {
                console.log(`addQssMnemonic 추가할 니모닉 이름 값 오류`, name)
                return false
            } else if(null == newMnemonic || '' === newMnemonic) {
                console.log(`addQssMnemonic 추가할 니모닉 코드 값 오류`, newMnemonic)
                return false
            }

            // 기존에 qss 저장된 데이터 불러오기
            const key = await getTelegramStorageKey(networkName);
            let qssValue = await downloadTgCloudStorage(key)
            console.log(`addQssMnemonic - 시작 networkName : ${networkName} | key : ${key} | qssValue : `, qssValue)

            // mnemonicHashList 와 mnemonicEnc 가 모두 없는지 확인
            // 없으면 초기상태로 설정
            if(null != qssValue && '' !== qssValue) {
                const parsedJsonData = JSON.parse(qssValue.toString());

                if (!parsedJsonData.hasOwnProperty('mnemonicHashList') && !parsedJsonData.hasOwnProperty('mnemonicEnc')) {
                    // console.log('mnemonicHashList / mnemonicEnc 둘 다 없음');
                    qssValue = null
                }
            }
            
            if(null == qssValue || '' === qssValue) {
                // 데이터 없을 경우 password로 새로 암호화 해서 저장. 배열에 저장
                const structQssMnemonic = {} as StructQssMnemonic;
                const mnemonicHashArray: QssMnemonicHash[] = [];
                const mnemonicArray: QssMnemonic[] = [];
                
                // structQssMnemonic.mnemonicsHash
                // structQssMnemonic.mnemonics

                // 이름-니모닉코드 해시
                const hash = await hashSha256Value(newMnemonic)
                const qssMnemonicHash:QssMnemonicHash = {
                    "network": networkName,
                    "name": name,
                    "mnemonicHash": hash
                }
                mnemonicHashArray.push(qssMnemonicHash)

                // structQssMnemonic에 니모닉해시 저장
                structQssMnemonic.mnemonicHashList = mnemonicHashArray

                // 이름-니모닉코드
                const qssMnemonic:QssMnemonic = {
                    "network": networkName,
                    "name": name,
                    "mnemonic": newMnemonic
                }
                mnemonicArray.push(qssMnemonic)
                
                // 이름-니모닉코드 json stringfy 처리
                const stringifyArray = JSON.stringify(mnemonicArray)
                // console.log(`addQssMnemonic 신규- stringifyArray : `, stringifyArray)

                // json 데이터 암호화
                const encData = await encryptValue(password, stringifyArray);
                // console.log(`addQssMnemonic 신규- encData 결과 : `, encData)

                // 암호화 된 값 structQssMnemonic 에 저장
                structQssMnemonic.mnemonicEnc = encData
                // console.log(`addQssMnemonic 신규- structQssMnemonic : `, structQssMnemonic)

                // structQssMnemonic 데이터 stringify 처리
                const strQssMnemonicList = JSON.stringify(structQssMnemonic)
                // console.log(`addQssMnemonic 신규- strQssMnemonicList : `, strQssMnemonicList)

                // structQssMnemonic 데이터 tg cloud로 저장
                const uploadResult = await uploadTgCloudStorage(key, strQssMnemonicList)
                // console.log(`addQssMnemonic 신규- uploadTgCloudStorage 결과 : `, uploadResult)

                return uploadResult
            } else {
                // 데이터 있을 경우

                // json 배열 형태로 변경
                const parsedData = JSON.parse(qssValue.toString());
                // console.log(`addQssMnemonic - 추가 parsedData`, parsedData)

                // parsedData.mnemonicsHash
                // parsedData.mnemonics
                const structQssMnemonic = parsedData

                // 기존 니모닉 해시 배열
                const mnemonicHashArray = structQssMnemonic.mnemonicHashList
                
                // 이름-니모닉코드 해시 추가
                const hash = await hashSha256Value(newMnemonic)
                const qssMnemonicHash:QssMnemonicHash = {
                    "network": networkName,
                    "name": name,
                    "mnemonicHash": hash
                }
                mnemonicHashArray.push(qssMnemonicHash)

                // 니모닉해시 정보 추가
                structQssMnemonic.mnemonicHashList = mnemonicHashArray;

                // 기존 니모닉 데이터
                const qssMnemonicEnc = structQssMnemonic.mnemonicEnc

                // 니모닉데이터 복호화
                const decryptedValue = decryptValue(password, qssMnemonicEnc);
                console.log(`addQssMnemonic - 추가 decryptedValue`, decryptedValue)

                let parsedDecryptedValue = decryptedValue?.toString() || '';
                if (parsedDecryptedValue.trim() === '') {
                    // 빈 문자열이면 빈 배열 문자열로 교체
                    parsedDecryptedValue = '[]';
                }

                // 불러온 데이터 배열에 저장
                const decJsonArray: QssMnemonic[] = JSON.parse(parsedDecryptedValue.toString());
                console.log(`addQssMnemonic - 추가 decJsonArray`, decJsonArray)

                if(false === await isMnemonicDuplicate(decJsonArray, networkName, newMnemonic))
                {
                    // 중복 없으면 배열에 니모닉 추가
                    const qssMnemonic:QssMnemonic = {
                        "network": networkName,
                        "name": name,
                        "mnemonic": newMnemonic
                    }
                    decJsonArray.push(qssMnemonic)
                } else {
                    // 중복이면 추가 저장하지 않고 리턴
                    return true;
                }

                // 니모닉 json 배열 생성. stringfy 처리
                const stringifyArray = JSON.stringify(decJsonArray)
                // console.log(`addQssMnemonic 추가 - stringifyArray 니모닉 배열 : `, stringifyArray)

                // 암호화
                const encData = await encryptValue(password, stringifyArray);
                // console.log(`addQssMnemonic 추가 - 암호화된 니모닉 배열 : `, encData)

                // 암호화 된 값 structQssMnemonic 에 저장
                structQssMnemonic.mnemonicEnc = encData
                // console.log(`addQssMnemonic 추가 - structQssMnemonic : `, structQssMnemonic)

                const strQssMnemonic = JSON.stringify(structQssMnemonic)
                // console.log(`addQssMnemonic 추가 - strQssMnemonic : `, strQssMnemonic)

                const uploadResult = await uploadTgCloudStorage(key, strQssMnemonic)
                // console.log(`addQssMnemonic 추가 - uploadTgCloudStorage 결과 : `, uploadResult)

                return uploadResult
            }
        } catch (error) {
            console.error('fail AddQssMnemonic', error);
        }      
        return false;
    };
    
    /**
     * qSS의 지정한 니모닉 코드 삭제
     * @param password 
     * @param network : 블록체인 네트워크
     * @param delMnemonic : 삭제할 니모닉
     * @returns 
     */
    const removeQssMnemonic = async (password: string, network:string, delMnemonic: string) => {
        try { 
            if(null == delMnemonic || '' === delMnemonic) {
                console.log(`addQssMnemonic 삭제할 니모닉 값 오류`, delMnemonic)
                return false
            }

            // 기존에 qss 저장된 암호화된 데이터 불러오기
            const key = await getTelegramStorageKey(network);
            const qssValue = await downloadTgCloudStorage(key)

            if(null == qssValue || '' === qssValue) {
                // 저장된 데이터가 없으면 리턴
                console.log(`removeQssMnemonic qssValue is empty`)
                return true;
            }

            const parsedData = JSON.parse(qssValue.toString());
            console.log(`removeQssMnemonic password`, password)
            console.log(`removeQssMnemonic parsedData`, parsedData)


            // 기존 니모닉 데이터
            const qssMnemonicHash = parsedData.mnemonicHashList 
            const qssMnemonicEnc = parsedData.mnemonicEnc
            console.log(`removeQssMnemonic 삭제 전 QSS 니모닉 해시 데이터`, qssMnemonicHash)
            console.log(`removeQssMnemonic 삭제 전 QSS 니모닉 데이터`, qssMnemonicEnc)

            // 복호화
            const decryptedValue = decryptValue(password, qssMnemonicEnc);
            console.log(`removeQssMnemonic 삭제 전 decryptedValue`, decryptedValue)

            // 이전 데이터 배열에 저장
            const decJsonArray: QssMnemonic[] = JSON.parse(decryptedValue.toString());
            
            // 일치하는 니모닉 있는지 확인
            if(true === await isMnemonicDuplicate(decJsonArray, network, delMnemonic)) {

                // 삭제할 니모닉코드 hash 생성
                const hash = await hashSha256Value(delMnemonic);
                console.log(`removeQssMnemonic 삭제할 니모닉해시`, hash)

                // qss 의 니모닉해시 데이터 json 배열로 변경
                const hashJsonArray: QssMnemonicHash[] = qssMnemonicHash;
                console.log(`removeQssMnemonic 삭제 전 hashJsonArray`, hashJsonArray)

                // 삭제할 네트워크-니모닉해시와 일치하지 않는 리스트 추출
                const updatedHashArray = hashJsonArray.filter(item => !(item.mnemonicHash === hash && item.network.toLowerCase() === network.toLowerCase()))
                console.log(`removeQssMnemonic 삭제후 업데이트 된 니모닉해시 배열`, updatedHashArray)

                // 변경된 니모닉 해시 parsedData 에 저장
                parsedData.mnemonicHashList = updatedHashArray
                console.log(`removeQssMnemonic 니모닉해시 삭제후 parsedData`, parsedData)


                // 삭제할 네트워크-니모닉코드와 일치하는 항목 제거
                const updatedArray = decJsonArray.filter(item => !(item.mnemonic === delMnemonic && item.network.toLowerCase() === network.toLowerCase()))
                console.log(`removeQssMnemonic 삭제 후 업데이트 니모닉 배열`, updatedArray)

                // 갱신된 니모닉 배열 json stringify
                const stringifyArray = JSON.stringify(updatedArray)
                console.log(`removeQssMnemonic 삭제 후 stringifyArray`, stringifyArray)

                // 변경된 니모닉 배열 암호화
                const encData = await encryptValue(password, stringifyArray);

                // 암호화 된 니모닉 데이터 parsedData 에 저장
                parsedData.mnemonicEnc = encData
                console.log(`removeQssMnemonic 삭제 후 - parsedData : `, parsedData)

                // 암호화된 데이터 json stringify  
                const encString = JSON.stringify(parsedData)
                console.log(`removeQssMnemonic 삭제 후 encString`, encString)

                const uploadResult = await uploadTgCloudStorage(key, encString)
                console.log(`removeQssMnemonic 삭제된 배열 tg 클라우드 업데이트 결과`, uploadResult)

                return uploadResult
            } else {
                console.log(`removeQssMnemonic 삭제할 니모닉 없음`)
            }
        } catch(error){
            console.warn('Error removeQssMnemonic', error);
        }

        return false;
    }

    /**
     * 지정한 QSS 니모닉이름 변경
     * @param password 
     * @param newName 
     * @param index 
     * @param network 
     * @returns 
     */
    const editNameQssMnemonic = async (password: string, newName: string, index:number, network:string) => {
        if( null == newName || '' === newName) {
            console.log(`1.editNameQssMnemonic 변경할 니모닉 이름 값 오류`, newName)
            return false
        }

        try {
            // 기존에 qss 저장된 암호화된 데이터 불러오기
            const key = await getTelegramStorageKey(network);            
            const qssValue = await downloadTgCloudStorage(key)
            // console.log(`addQssMnemonic - 시작 qssValue`, qssValue)

            if(null == qssValue || '' === qssValue) {
                // 저장된 데이터가 없으면 리턴
                console.log(`1-2.editNameQssMnemonic qssValue is empty`)
                return false;
            }

            const parsedData = JSON.parse(qssValue.toString());
            console.log(`2-1.editNameQssMnemonic password`, password)
            console.log(`2-2.editNameQssMnemonic parsedData`, parsedData)

            // QSS 니모닉해시
            const qssMnemonicHash = parsedData.mnemonicHashList

            // qss 의 니모닉해시 데이터 json 배열로 변경
            const hashJsonArray: QssMnemonicHash[] = qssMnemonicHash;
            console.log(`2-3.editNameQssMnemonic hashJsonArray`, hashJsonArray)

            if (index >= 0 && index < hashJsonArray.length) {
                hashJsonArray[index].name = newName; // name 값을 변경
            } else {
                console.error("2-4.잘못된 인덱스번호. 니모닉해시 이름 변경하지 않음");
                return false;
            }

            // 변경된 니모닉해시 데이터 parsedData 에 저장
            parsedData.mnemonicHashList = hashJsonArray
            console.log(`3.editNameQssMnemonic 니모닉해시 이름 변경 후 - parsedData : `, parsedData)




            // 변경된 QSS 니모닉
            const qssMnemonicEnc = parsedData.mnemonicEnc

            // 변경된 QSS 니모닉 복호화
            const decryptedValue = decryptValue(password, qssMnemonicEnc);

            // 이전 데이터 배열에 저장
            const decJsonArray: QssMnemonic[] = JSON.parse(decryptedValue.toString());

            if (index >= 0 && index < decJsonArray.length) {
                decJsonArray[index].name = newName; // name 값을 변경
            } else {
                console.error("4-1.잘못된 인덱스번호. 니모닉이름 변경하지 않음");
                return false;
            }

            // 갱신된 배열 json stringify
            const stringifyArray = JSON.stringify(decJsonArray)
            console.log(`4-2.editNameQssMnemonic 니모닉이름 변경 후 stringifyArray`, stringifyArray)

            // 배열 암호화
            const encData = await encryptValue(password, stringifyArray);

            // 암호화 된 니모닉 데이터 parsedData 에 저장
            parsedData.mnemonicEnc = encData
            console.log(`4-3.editNameQssMnemonic 변경 후 - parsedData : `, parsedData)

            // 암호화된 데이터 json stringify  
            const encString = JSON.stringify(parsedData)
            console.log(`4-4.editNameQssMnemonic 변경 후 encString`, encString)

            const uploadResult = await uploadTgCloudStorage(key, encString)
            console.log(`4-5.editNameQssMnemonic 이름 변경된 니모닉 배열 클라우드 업데이트 결과`, stringifyArray)

            // qss 니모닉해시 이름변경
            // if(true === uploadResult) {
            //     console.log(`editNameQssMnemonic 니모닉해시 이름 변경 시작 : ${newName} | ${index}`, )
            //     await editNameQssMnemonicHash(newName, index)
            // }

            return uploadResult
        } catch(error) {
            console.warn('Error editNameQssMnemonic', error);
        }

        return false;
    }

    /**
     * qss에 저장된 니모닉 코드 clear
     * @returns 
     */
    const clearQssMnemonic = async (network:string) => {
        let result = false;
        let value = null;

        try {
            const key = await getTelegramStorageKey(network);
            const clearResult = await clearTgCloudStorage(key)
            console.log(`clearQssMnemonic - ${key} clearResult : `, clearResult)
            if(true === clearResult) {
                result = true;
            }
        } catch (error) {
            console.error('Error clearQssMnemonic', error);
        }

        return {result, value};
    };

    /**
     * 니모닉 배열에 니모닉코드 중복 여부 확인 함수
     * @param array 
     * @param network : 네트워크
     * @param newItem : 니모닉
     * @returns 
     */
    const isMnemonicDuplicate = (array: QssMnemonic[], network:string, newItem: string): boolean => {
        console.log(`isMnemonicDuplicate array`, array)
        console.log(`isMnemonicDuplicate network`, network)
        console.log(`isMnemonicDuplicate newItem`, newItem)
        return array.some(item => (item.mnemonic === newItem && item.network.toLowerCase() === network.toLowerCase()))
    };

    /**
     * 니모닉해시 배열에 해시값 중복 여부 확인 함수 
     * @param array 
     * @param newItem 
     * @param network 
     * @returns 
     */

    const isMnemonicHashDuplicate = (array: QssMnemonicHash[], newItem: string, network:string): boolean => {
        // console.log(`isMnemonicHashDuplicate array`, array)
        // console.log(`isMnemonicHashDuplicate newItem`, newItem)
        // console.log(`isMnemonicHashDuplicate network`, network)
        return array.some(item => item.mnemonicHash === newItem.trim() && item.network.toLowerCase() === network.toLowerCase());

        // return array.some(item => {
        //     console.log("Comparing:", item.mnemonicHash, "with", newItem);

        //     console.log("Length of item.mnemonicHash:", item.mnemonicHash.length);
        //     console.log("Length of newItem.trim():", newItem.trim().length);

        //     console.log("Type of item.mnemonicHash:", typeof item.mnemonicHash);
        //     console.log("Type of newItem.trim():", typeof newItem.trim());

        //     return item.mnemonicHash === newItem.trim();
        // });
    }

    // 외부 export할 함수 이름 설정
    return {
        checkOverlapQssMnemonicHash,
        getQssMnemonicHash,
        checkEmptyQssMnemonic,
        checkOldQssData,
        chackQssPassword,
        getQssMnemonic,
        addQssMnemonic,
        removeQssMnemonic,
        editNameQssMnemonic,
        clearQssMnemonic,
    };

}

export default useQssMnemonic;